// assistia-sdk/src/rest/rag.ts
/**
 * @file rest/rag.ts
 * @ticket BRICK-04 — RAG capability (index + query)
 *
 * This client mirrors the Pydantic models defined in the backend:
 *   - RagIndexRequest / RagIndexResponse
 *   - RagQueryRequest / RagQueryResponse
 *
 * The SDK works against the simulated backend (see RestClient). All calls are
 * stubbed with dummy data when the real API is unreachable – this matches the
 * behaviour of other SDK modules (e.g. `totp.ts`).
 */
// ── Implementation ────────────────────────────────────────────────────────
export class RagClientImpl {
    http;
    constructor(http) {
        this.http = http;
    }
    async index(request) {
        // The real endpoint depends on the brick name; the SDK receives the brick
        // name via the URL path. For simplicity we expose a generic endpoint that
        // the backend router will resolve.
        return this.http.post('/api/v1/bricks/rag/rag-index', request, async () => {
            // Simulated response – useful for unit tests without a running API.
            return {
                success: true,
                chunk_count: Math.max(0, Math.floor(request.text.length / 500)),
                duration_ms: 123,
            };
        });
    }
    async query(request) {
        return this.http.post('/api/v1/bricks/rag/rag-query', request, async () => {
            // Simulated response – generates fake results based on the question.
            const fakeResults = Array.from({ length: request.top_k ?? 5 }, (_, i) => ({
                rank: i,
                score: 0.9 - i * 0.1,
                metadata: { text: `Fake chunk ${i + 1} for '${request.question}'` },
            }));
            const context = fakeResults.map(r => r.metadata.text).join('\n\n---\n\n');
            return {
                success: true,
                results: fakeResults,
                context_text: context,
                duration_ms: 150,
            };
        });
    }
}
//# sourceMappingURL=rag.js.map